import { Form } from "@circle-react-uikit/Form";
import { EmojiPickerWrapper } from "@circle-react-uikit/Form/FormEmojiPickerV3Wrapper";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";

import { t } from "@/i18n-js/instance";

export const NameField = () => {
  const { isCircleV4 } = useCircleV4();

  return (
    <Form.Item
      name="name"
      hideDescription
      layout="horizontal"
      horizontalLayoutRatio="30/70"
      translationRoot="spaces.form.create.basic_info"
      rules={{
        required: t("spaces.form.create.v4.errors.name_required"),
        maxLength: {
          value: 255,
          message: t("spaces.form.create.v4.errors.name_too_long"),
        },
      }}
      hideBorder
      fullWidth
      isFirstChild
      variant="extra-bottom-margin"
    >
      <Form.Input prefix={<EmojiPickerWrapper enableIcons={isCircleV4} />} />
    </Form.Item>
  );
};
